import {Injectable} from '@angular/core';
import {ChartDialogPruefungDerVariablenM1Component} from '../../../kontrolle/cockpit-m1/pruefung-der-variablen/chart-dialog-pruefung-der-variablen-m1.component';
import {ChartDialogPruefungDerVariablenM2Component} from '../../../kontrolle/cockpit-m2/chart-dialog-pruefung-der-variablen-component-m2/chart-dialog-pruefung-der-variablen-m2.component';
import {CockpitCard} from 'shared/dtos/cockpit-card';
import {DataService} from 'shared/services/data.service';
import {MessageService} from 'shared/services/message.service';
import {ChartDialogGrafischerModellcheckComponent} from '../../../cockpit-m1/kontrollmodus/chart-dialog-grafischer-modellcheck/chart-dialog-grafischer-modellcheck.component';
import {CockpitBaseService} from './cockpit-base.service';
import {DataStorageService} from 'shared/services/data-storage.service';
import {EinflussExtremwerteM1Component} from '../../../kontrolle/cockpit-m1/einfluss-extremwerte-m1/einfluss-extremwerte-m1.component';
import {ChartDialogEinflussVonExtremwertenM2Component} from '../../../kontrolle/cockpit-m2/chart-dialog-einfluss-von-extremwerten-m2/chart-dialog-einfluss-von-extremwerten-m2.component';
import {ModellvariantenComponent as ModellvariantenM1Component} from '../../../kontrolle/cockpit-m1/modellvarianten/modellvarianten.component';
import {ModellvariantenM2Component} from '../../../kontrolle/cockpit-m2/modellvarianten-m2/modellvarianten-m2.component';
import {ChartDialogWeitereFunktionenstatistikenComponent} from '../../../kontrolle/shared-components/chart-dialog-weitere-funktionenstatistiken/chart-dialog-weitere-funktionenstatistiken.component';
import {PruefungKombinationenUnabhaengigerVariablenComponent} from '../../../kontrolle/cockpit-m1/pruefung-kombinationen-unabhaengiger-variablen/pruefung-kombinationen-unabhaengiger-variablen.component';
import {ChartCurrentCodesComponent} from '../../../cockpit-m1/kontrollmodus/chart-current-codes/chart-current-codes.component';
import {ChartLeaveOneOutComponent} from '../../contents/leave-one-out/chart-leave-one-out.component';

@Injectable({providedIn: 'root'})
export class CockpitKontrolleService extends CockpitBaseService {
  protected readonly cardsData: CockpitCard[] = [
    {
      component: ChartDialogPruefungDerVariablenM1Component,
      name: 'PruefungDerVariablenM1Component',
      title: 'm1-m2.sprint7.cockpit.card.pruefung-der-variablen.title',
      isSelected: true,
      content: [
        'm1-m2.sprint7.cockpit.card.pruefung-der-variablen.content.1',
        'm1-m2.sprint7.cockpit.card.pruefung-der-variablen.content.2'
      ],
      position: 1,
      module: 1
    },
    {
      component: ChartDialogPruefungDerVariablenM2Component,
      name: 'PruefungDerVariablenM2Component',
      title: 'm1-m2.sprint7.cockpit.card.pruefung-der-variablen.title',
      isSelected: true,
      content: [
        'm1-m2.sprint7.cockpit.card.pruefung-der-variablen.content.1',
        'm1-m2.sprint7.cockpit.card.pruefung-der-variablen.content.2'
      ],
      position: 1,
      module: 2
    },
    {
      component: PruefungKombinationenUnabhaengigerVariablenComponent,
      name: 'PruefungKombinationenUnabhaengigerVariablenComponent',
      title:
        'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.title',
      isSelected: false,
      content: [
        'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.content.1',
        'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.content.2',
        'm1.sprint10.cockpit-kontrolle.pruefung-kombinationen-unabhaengiger-variablen.content.3'
      ],
      position: 2,
      module: 1
    },
    {
      component: ChartDialogWeitereFunktionenstatistikenComponent,
      name: 'WeitereFunktionenstatistiken',
      title: 'm2.sprint9.cockpit.card.weitereFunktionenstatistiken.title',
      isSelected: false,
      content: [
        'm1.sprint10.cockpit.card.weitereFunktionenstatistiken.content.1',
        'm1.sprint10.cockpit.card.weitereFunktionenstatistiken.content.2',
        'm1.sprint10.cockpit.card.weitereFunktionenstatistiken.content.3'
      ],
      position: 3,
      module: 1
    },
    {
      component: ChartDialogWeitereFunktionenstatistikenComponent,
      name: 'WeitereFunktionenstatistiken',
      title: 'm2.sprint9.cockpit.card.weitereFunktionenstatistiken.title',
      isSelected: false,
      content: [
        'm2.sprint9.cockpit.card.weitereFunktionenstatistiken.content.1',
        'm2.sprint9.cockpit.card.weitereFunktionenstatistiken.content.2'
      ],
      position: 2,
      module: 2
    },
    {
      component: ChartDialogEinflussVonExtremwertenM2Component,
      name: 'EinflussVonExtremwertenM2Component',
      title: 'm1-m2.sprint7.cockpit-kontrolle.einfluss-extremwerte.title',
      isSelected: false,
      content: ['m2.sprint7.cockpit-kontrolle.einfluss-extremwerte.content.1'],
      position: 4,
      module: 2
    },
    {
      component: ChartDialogGrafischerModellcheckComponent,
      name: 'GrafischerModellcheck',
      title: 'm1.sprint5.cockpit.card.grafischerModellcheck.title',
      isSelected: false,
      content: [
        'm1.sprint5.cockpit.card.grafischerModellcheck.content.1',
        'm1.sprint5.cockpit.card.grafischerModellcheck.content.2'
      ],
      position: 5,
      module: 1
    },
    {
      component: EinflussExtremwerteM1Component,
      name: 'EinflussExtremwerte',
      title: 'm1.sprint7.cockpit-kontrolle.einfluss-extremwerte.title',
      isSelected: false,
      content: ['m1.sprint7.cockpit-kontrolle.einfluss-extremwerte.card.1'],
      position: 4,
      module: 1
    },
    {
      component: ModellvariantenM1Component,
      name: 'Modellvarianten',
      title: 'm1+2.sprint9.cockpit-kontrolle.modellvarianten.title',
      content: [
        'm1.sprint8.cockpit-kontrolle.modellvarianten.content.1',
        'm1.sprint8.cockpit-kontrolle.modellvarianten.content.2',
        'm1.sprint8.cockpit-kontrolle.modellvarianten.content.3',
        'm1.sprint8.cockpit-kontrolle.modellvarianten.content.4'
      ],
      isSelected: false,
      position: 6,
      module: 1
    },
    {
      component: ChartCurrentCodesComponent,
      name: 'ChartCurrentCodesComponent',
      title: 'm1.cockpit-kontrolle.card.currentCodes.title',
      isSelected: false,
      content: ['m1.cockpit-kontrolle.card.currentCodes.content.1'],
      position: 7,
      module: 1
    },
    {
      component: ModellvariantenM2Component,
      name: 'Modellvarianten',
      title: 'm1+2.sprint9.cockpit-kontrolle.modellvarianten.title',
      content: [
        'm2.sprint9.cockpit-kontrolle.modellvarianten.content.1',
        'm2.sprint9.cockpit-kontrolle.modellvarianten.content.5'
      ],
      isSelected: false,
      position: 7,
      module: 2
    },
    {
      component: ChartLeaveOneOutComponent,
      name: 'LeaveOneOut',
      title: 'm2.ergebnis.robustheitsmass',
      content: ['m2.cockpit.card.verteilung-leave-one-out'],
      isSelected: false,
      position: 8,
      module: 2
    }
  ];

  constructor(
    protected readonly storage: DataStorageService,
    protected readonly _dataService: DataService,
    protected readonly _messageService: MessageService
  ) {
    super(_dataService, _messageService);
  }

  public async getCockpitCardData(): Promise<CockpitCard[] | null> {
    const data = await this.storage.getCockpitKontrolle();
    if (data) {
      return super.getCockpitCardData();
    }
    return null;
  }
}
